import { cpOrderFormApiConnector } from 'apiConnector/secondary-market/cp-order/form';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';
import {
  secondaryMarketCpOrderAmendFailedThunk,
  secondaryMarketCpOrderAmendReceivedThunk,
} from 'state/secondaryMarket/cpOrder/amend/amendedOrder.thunks';
import type { EpicWithThunk } from 'state/state.common';
import type { HttpError } from 'utils/http/httpClient.model';

import { getTabRemoved$ } from '../utils';

export function amendOrderEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient, frontLogger }) => {
    const { amendOrder } = cpOrderFormApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_CP_ORDER_AMEND_REQUESTED'),
      mergeMap(({ tabId, orderId, etag, request }) => {
        return amendOrder(orderId, etag, request).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          map(response => secondaryMarketCpOrderAmendReceivedThunk(tabId, response)),
          catchError((error: HttpError) => {
            frontLogger.error('An error occurred inside amendOrderEpic {@FrontError}', error);
            return of(secondaryMarketCpOrderAmendFailedThunk(tabId, error));
          }),
        );
      }),
    );
  };
}
